module.exports = __webpack_public_path__ + "front/img/p1_2.b04229ff.png";